<template>
  <el-container
    :style="cmsContentLoaded ? cmsStyles : {}"
    :class="{ hidden: !cmsContentLoaded, fullHeight }"
  >
    <el-header height="auto">
      <Header />
    </el-header>

    <el-main>
      <YMMQualifiers ref="globalYMMQualifiers" />
      <router-view :key="router.path" :class="{ hidden: qualifiersOpened }" />
    </el-main>

    <el-footer height="70px">
      <Footer />
    </el-footer>
 </el-container>
</template>
<script>
import YMMQualifiers from '@/components/ymm/YMMQualifiers'
import { useStore } from 'vuex'
import { CMSStyles } from '@/lib/CustomStyles'
import Header from '@/components/global/Header'
import Footer from '@/components/global/Footer'
import { ref, provide, computed, onMounted, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import { useGetters } from '@/lib/helpers'

export default {
  components: {
    Header,
    Footer,
    YMMQualifiers
  },
  setup () {
    const qualifiersOpened = ref(false)
    const store = useStore()
    const cmsStyles = CMSStyles()
    const globalYMMQualifiers = ref(null)
    const cmsContentLoaded = ref(false)
    const router = useRoute()
    const { cmsFavicon } = useGetters(['cmsFavicon'])
    const { cmsVendorName } = useGetters(['cmsVendorName'])
    const { cmsGeneralSettings } = useGetters(['cmsGeneralSettings'])

    const fullHeight = computed(() => router.name === 'Home' || router.name === 'HomeSearchYMM' || router.name === 'HomeSearchBVId' || qualifiersOpened.value)
    provide(
      'YMMQualifiersGlobal',
      computed(() => globalYMMQualifiers.value)
    )

    const updateFavicon = (url) => {
      let link = document.querySelector("link[rel~='icon']")
      if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.getElementsByTagName('head')[0].appendChild(link)
      }
      link.href = url
    }

    const updateTitle = (vendor) => {
      document.title = `${vendor} - Microsite`
    }

    const addHotJar = (id) => {
      if (id) {
        const script = document.createElement('script')
        script.innerHTML = `
          (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:${id},hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `
        document.head.appendChild(script)
      }
    }

    const addGoogleAnalytics = (id) => {
      if (id) {
        const script = document.createElement('script')
        script.async = true
        script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
        document.head.appendChild(script)

        const scriptData = document.createElement('script')
        scriptData.innerHTML = `
          window.dataLayer = window.dataLayer || [];   
          function gtag(){dataLayer.push(arguments);}   
          gtag('js', new Date());    
          gtag('config', '${id}');
        `
        document.head.appendChild(scriptData)
      }
    }

    watchEffect(() => {
      qualifiersOpened.value = globalYMMQualifiers?.value?.qualifiersOpen || false
    })

    onMounted(async () => {
      await store.dispatch('getCMSData')
      cmsContentLoaded.value = true
      updateFavicon(cmsFavicon.value)
      updateTitle(cmsVendorName.value)
      addHotJar(cmsGeneralSettings.value?.hotjar_id)
      addGoogleAnalytics(cmsGeneralSettings.value?.google_analytics_id)
    })

    return {
      cmsStyles,
      globalYMMQualifiers,
      qualifiersOpened,
      cmsContentLoaded,
      fullHeight,
      router
    }
  }
}
</script>

<style lang="scss">
* {
  font-family: "interstate";
  font-size: 13px;
}
html,
body {
  width: 100%;
  height: 100%;
  margin: 0px;
}
html {
  overflow: hidden;
  overflow-y: auto;
}
// Override Element UI's icon font
$fa-css-prefix: "icon-fa";
@import "~@fortawesome/fontawesome-pro/scss/fontawesome.scss";
// @include mf-font-awesome();

h1, h1 strong {
  @include mf-bold(36px);
}
p strong {
  @include mf-bold(26px);
}
h2 {
  @include mf-bold(28px);
}
h3 {
  @include mf-bold(18px);
}
.secondary-nav-link {
  @include mf-bold($mf-secondary-nav-font-size);
}

.hidden {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
}
.autoAlphaHidden {
  opacity: 0;
  visibility: hidden;
}

.is-disabled {
  opacity: 0.6;
}
.underline {
  text-decoration: underline;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $mf-body-color;
  height: inherit;
  .el-header {
    position: fixed;
    width: 100%;
    z-index: 9 !important;
  }
  .el-main {
    margin-top: 60px;
    padding: 0px;
  }
  .el-container {
    min-height: 100%;
    &.fullHeight {
      height: 100%;
    }
  }
  .el-footer,
  .el-header {
    padding: 0;
  }
  .el-footer {
    border-top: $mf-border-color solid thin;
    padding: 0 28px;
  }
  .el-footer,
  .el-header {
    z-index: 2;
  }
}
</style>
